import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotComponent } from './chatbot.component';
import { ChatbotHeaderComponent } from './components/chatbot-header/chatbot-header.component';
import { ChatbotFooterComponent } from './components/chatbot-footer/chatbot-footer.component';
import { ChatbotMainComponent } from './components/chatbot-main/chatbot-main.component';
import { NewChatTemplateComponent } from './components/chatbot-main/new-chat-template/new-chat-template.component';
import { WarningTemplateComponent } from './components/chatbot-main/warning-template/warning-template.component';
import { MessagesTemplateComponent } from './components/chatbot-main/messages-template/messages-template.component';
import { UnreadIconComponent } from './unread-icon/unread-icon.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ChatbotState } from './state/chatbot.state';
import { NgxsModule } from '@ngxs/store';
import { MarkdownModule } from '../markdown/markdown.module';
import { CustomButtonModule } from '../custom-button/custom-button.module';
import { LoadingSpinnerModule } from '../loading-spinner/loading-spinner.module';

@NgModule({
  imports: [
    NgxsModule.forFeature([ChatbotState]),
    CommonModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ClipboardModule,
    MatSnackBarModule,
    CustomButtonModule,
    MarkdownModule,
    LoadingSpinnerModule
  ],
  declarations: [
    ChatbotComponent,
    ChatbotHeaderComponent,
    ChatbotFooterComponent,
    ChatbotMainComponent,
    NewChatTemplateComponent,
    WarningTemplateComponent,
    MessagesTemplateComponent,
    UnreadIconComponent
  ],
  exports: [
    ChatbotComponent,
    ChatbotHeaderComponent,
    ChatbotFooterComponent,
    ChatbotMainComponent,
    NewChatTemplateComponent,
    WarningTemplateComponent,
    MessagesTemplateComponent,
    UnreadIconComponent
  ]
})
export class ChatbotModule {}
